export default "__VITE_ASSET__BlwtmPBP__"